<agpr-dialog-container
    heading="Discover.distributionDashboard.getMoreRecipients"
    (close)="cancel()"
    [contentPadding]="false"
>
    <div
        class="agpr-buyQuota"
        [agprLoading]="loading"
    >
        <div class="agpr-buyQuota-container">
            <agpr-scroll-panel class="agpr-buyQuota-scrollPanel">
                <div class="agpr-buyQuota-header">
                    <div
                        class="agpr-i-line-distribution agpr-buyQuota-header-icon"
                        aria-hidden="true"
                    ></div>
                    <div class="agpr-buyQuota-header-text">
                        <div>{{'Discover.buyQuota.header1' | localize}}</div>
                        <div>{{'Discover.buyQuota.header2' | localize}}</div>
                    </div>
                </div>
                <div class="agpr-buyQuota-content">
                    <div class="agpr-buyQuota-intro">
                        {{'Discover.buyQuota.intro1' | localize}}
                        {{'Discover.buyQuota.intro2' | localize}}
                    </div>
                    <agpr-message
                        [severity]="messageSeverities.info"
                        [bottomMargin]="false"
                    >
                        <span>{{'Discover.buyQuota.message' | localize}}</span>
                        <a
                            [href]="quotaUrl"
                            target="_blank"
                            class="agpr-buyQuota-link"
                        >
                            {{'Discover.buyQuota.message.pricingInfo' | localize }}.
                        </a>
                    </agpr-message>
                    <div class="agpr-buyQuota-bundles-container">
                        <button
                            class="agpr-buyQuota-bundles-bundle"
                            [ngClass]="{'agpr-buyQuota-bundles-bundle-selected' : selectedAmount === 5000}"
                            (agprClickUnless)="selectedAmount = 5000"
                        >
                            <span class="agpr-buyQuota-bundles-bundle-divider"></span>
                            <span class="agpr-buyQuota-bundles-bundle-amount">
                                5,000
                            </span>
                            <span class="agpr-buyQuota-bundles-bundle-recipient">
                                {{'Discover.buyQuota.recipients' | localize}}
                            </span>
                        </button>
                        <button
                            class="agpr-buyQuota-bundles-bundle"
                            [ngClass]="{'agpr-buyQuota-bundles-bundle-selected' : selectedAmount === 25000}"
                            (agprClickUnless)="selectedAmount = 25000"
                        >
                            <span class="agpr-buyQuota-bundles-bundle-divider"></span>
                            <span class="agpr-buyQuota-bundles-bundle-amount">
                                25,000
                            </span>
                            <span class="agpr-buyQuota-bundles-bundle-recipient">
                                {{'Discover.buyQuota.recipients' | localize}}
                            </span>
                        </button>
                        <button
                            class="agpr-buyQuota-bundles-bundle"
                            [ngClass]="{'agpr-buyQuota-bundles-bundle-selected' : selectedAmount === 50000}"
                            (agprClickUnless)="selectedAmount = 50000"
                        >
                            <span class="agpr-buyQuota-bundles-bundle-divider"></span>
                            <span class="agpr-buyQuota-bundles-bundle-amount">
                                50,000
                            </span>
                            <span class="agpr-buyQuota-bundles-bundle-recipient">
                                {{'Discover.buyQuota.recipients' | localize}}
                            </span>
                        </button>
                    </div>
                    <div class="agpr-buyQuota-contact">
                        <div>{{'Discover.buyQuota.contact1' | localize}}</div>
                        <div>{{'Discover.buyQuota.contact2' | localize}}
                            <a
                                [href]="contactLink"
                                target="_blank"
                                class="agpr-buyQuota-link"
                            >
                                {{'Discover.buyQuota.contact.link' | localize }}
                            </a>
                        </div>
                    </div>
                </div>
            </agpr-scroll-panel>
        </div>
        <div class="agpr-buyQuota-disclaimer">
            <agpr-checkbox
                id="buyQuotaDialog_consent1"
                [binary]="true"
                [(ngModel)]="consent1"
            >
                <span>
                    <span>{{'Discover.buyQuota.consent1' | localize}}</span>
                    <a
                        [href]="quotaUrl"
                        target="_blank"
                        class="agpr-buyQuota-link"
                    >
                        {{'Discover.buyQuota.message.pricingInfo' | localize }}
                    </a>
                    <span>{{'Discover.buyQuota.consent2' | localize}}</span>
                </span>
            </agpr-checkbox>
            <agpr-checkbox
                id="buyQuotaDialog_consent2"
                [binary]="true"
                label="Discover.buyQuota.consent3"
                [(ngModel)]="consent2"
            ></agpr-checkbox>
        </div>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            [id]="id + '.confirmDialog.cancel'"
            label="Core.button.cancel"
            [disabled]="loading"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            [id]="id + '.confirmDialog.ok'"
            [style]="buttonTypes.primary"
            label="Discover.buyQuota.purchaseBundle"
            [disabled]="loading || !(consent1 && consent2)"
            (click)="ok()"
        >
        </agpr-button>
    </ng-template>
</agpr-dialog-container>
